/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import { findAllTransactionsByCompanyId } from '@/services/api/customer/company';
// initial state
const state = {
  transactions: [],
};

// getters
const getters = {
  get: (state) => state.transactions,
};

// actions
const actions = {
  async getTransactions({ commit, rootGetters }) {
    const { id } = rootGetters['company/get'];
    if (id) {
      const success = await findAllTransactionsByCompanyId(id);
      commit('SET_VALUE', { transactions: success.data });
    }
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
  CLEAR(state) {
    Object.assign(state, {
      transactions: [],
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
